import React, { useEffect, useState } from "react";
import "./SideNavBar.scss";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { useNavigate, useParams, Outlet } from "react-router-dom";
import { SOE_FORMATTED_DATA } from "../../../globalConstants";
import { useDispatch, useSelector } from "react-redux";
import { PHONEME_DATA_LIST } from "./FeatureCourse/constants";
import { setTemplateTitle } from "../../../redux/actions/soundsOfEnglishActions";
import { removeBoldTags } from "./soeService";
import MenuIcon from "@material-ui/icons/Menu";
import SettingsVoiceIcon from '@material-ui/icons/SettingsVoice';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
interface SubMenu {
  id: number;
  name: string;
  link: string;
  version: string;
  submenu: {
    id: number;
    num: number;
    navcode: string;
    name: string;
    minTime: number;
    maxTime: number;
    classid: number;
    skill: number;
    type: string;
    demoName: string;
    link: string;
    vValue: string;
  };
}

const SideNavBar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { templateTitle } = useSelector((state: any) => state.soundsOfEnglish);
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(1);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const { activityId, templateID } = useParams();
  const [menus, setMenus] = useState<Array<any>>([]);
  const [hoverEffectActive, setHoverEffectActive] = useState(false);

  useEffect(() => {
    if (activityId) {
      const menus: any = SOE_FORMATTED_DATA.find((item: any) => item.Id == activityId);
      if (menus) {
        const menuData = menus?.filteredAssignments?.map((menu: any) => {
          const submenu = menu?.assignAssignment.activities?.map((submenu: any) => {
            return {
              id: submenu.id,
              name: submenu.demoName,
              link: submenu.link,
              version: submenu.vValue,
              submenu,
            };
          });
          const formattedMenu = {
            id: menu?.assignAssignment?.id,
            name: `${menus.symbol}, ${menu.Symbol}`,
            subMenus: submenu,
          };
          return formattedMenu;
        });
        setActiveMenu(menuData[0].id);
        setMenus([...menuData]);
      }
      if (templateTitle !== "") {
        const item = PHONEME_DATA_LIST.find((item: any) => item.Id == activityId);
        if (item) {
          const title = removeBoldTags(item?.Words[0]);
          dispatch(setTemplateTitle(`${item.symbol}(${title ?? ""})`));
        }
      }
    }
  }, []);

  useEffect(() => {
    if (templateID && menus.length) {
      for (const item of menus) {
        const foundSubMenu = item.subMenus.find((subMenu: SubMenu) => subMenu.id == Number(templateID));
        if (foundSubMenu) {
          setActiveMenu(Number(item.id));
          setActiveSubMenu(() => foundSubMenu.id);
        }
      }
    }
  }, [templateID, menus]);
  const toggleSideNav = () => {
    if(hoverEffectActive){
      setIsSideNavOpen(false);
    }else{
      setIsSideNavOpen(true);
    }
    setHoverEffectActive(!hoverEffectActive);
  };

  const handleSubMenuClick = (submenu: any) => {
    setActiveSubMenu(() => submenu.id);
    navigate(`${submenu.link}/${submenu.id}`, { state: submenu });
  };
  const handleMenuClick = (menu: any) => {
    setActiveSubMenu(null)
    if (activeMenu == menu.id) {
      setActiveMenu(0);
    } else {
      setActiveMenu(() => menu.id);
    }
    navigate(`/soundsofenglish/${activityId}`);
  };

  const getIcon = (link: any) => {
    switch (link) {
      case "findTheDiff":
        return <FindInPageIcon />;
      case "checkUnderstanding":
        return <PlaylistAddCheckIcon />;
      case "recordAndCompare":
        return <SettingsVoiceIcon />;
      case "chooseThePicture":
        return <ImageSearchIcon />;
      case "matchTheSound":
        return <RecordVoiceOverIcon />;
      default:
        break;
    }
  };

  const handleMouseEnter = () => {
    if (hoverEffectActive) {
      setIsSideNavOpen(true);
    }
  };
  const handleMouseLeave = () => {
    if (hoverEffectActive) {
      setIsSideNavOpen(false);
    }
  };
  return (
    <div data-testid="side-container" className="side-container">
      <div data-testid="side-nave" className={`side-nav ${isSideNavOpen ? "open" : ""}`}>
        <div className="side-nav-header">
          {!isSideNavOpen ? <span> Vowels: {templateTitle}</span> : ""}
          <span aria-hidden="true" data-testid="side-toggle" className="side-nav-header-icon" onClick={toggleSideNav}>
            <MenuIcon />
          </span>
        </div>
        <nav>
          <ul>
            {menus?.length > 0 &&
              menus.map((menu: any) => (
                <React.Fragment key={menu.id}>
                  <button
                    data-testid={`side-menu${menu.id}`}
                    onClick={() => handleMenuClick(menu)}
                    className={` side-menu remove-button-default-style-flex ${activeMenu == menu.id ? "menu-active" : ""}`}
                  >
                    <div className="side-nav-heading side-menu">{menu.name}</div>
                    {!isSideNavOpen ? (
                      <div data-testid="side-nav-icon" className="side-nav-icon ">
                        {activeMenu == menu.id ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                      </div>
                    ) : (
                      ""
                    )}
                  </button>
                  {menu.subMenus?.length > 0 &&
                    activeMenu == menu.id &&
                    menu.subMenus.map((submenu: any) => (
                      <React.Fragment key={submenu.id}>
                        <button
                          onClick={() => handleSubMenuClick(submenu)}
                          key={submenu.id}
                          className={`subMenus p-left  remove-button-default-style-flex ${activeSubMenu == submenu.id ? "submenu-active" : ""}`}
                        >
                          <div className="side-nav-icon">{getIcon(submenu.link)}</div>
                          {!isSideNavOpen ? <div>{submenu.name}</div> : ""}
                        </button>
                      </React.Fragment>
                    ))}
                </React.Fragment>
              ))}
          </ul>
        </nav>
      </div>
      <button
        className="outlet-container remove-button-default-style-outlet"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Outlet />
      </button>
    </div>
  );
};

export default SideNavBar;
